import { getPath } from '@/router/common'

const baseUrl = {
  title: '出纳审核',
  path: 'Cashier'
}

export default [
  {
    path: getPath('CashierAuditing', baseUrl),
    name: 'Cashier_CashierAuditing',
    component: () => import(/* webpackChunkName: "Cashier_CashierAuditing" */ '@/views/cashier/cashierAuditing/index.vue'),
    meta: {
      title: '出纳审核'
    }
  },
  {
    path: getPath('CashierZZ', baseUrl),
    name: 'Cashier_CashierZZ',
    component: () => import(/* webpackChunkName: "Cashier_CashierZZ" */ '@/views/cashier/cashierZZ/index.vue'),
    meta: {
      title: '出纳扎帐'
    }
  }
]
